<ng-template
  let-field="field"
  let-channel="channel"
  let-viewSource="viewSource"
  let-modeView="modeView"
  let-allowScalars="allowScalars"
  let-allowDiscrete="allowDiscrete"
  let-allowContinuous="allowContinuous"
  #dragAndDrop
>
  <mode-encoding-field-single
    (update)="fieldUpdated($event)"
    (remove)="removeField($event)"
    (removeSort)="removeSort($event)"
    [encoding]="encoding"
    [field]="field"
    [fieldFormatMap]="fieldFormatMap$ | async"
    [format]="format$ | async"
    [model]="model"
    [view]="modeView"
    [viewName]="viewSource"
    [vizToken]="vizToken$ | async"
    [chartType]="chartType"
    [allowScalars]="allowScalars"
    [allowAggregates]="true"
    [allowDiscrete]="allowDiscrete"
    [allowContinuous]="allowContinuous"
  ></mode-encoding-field-single>
</ng-template>

<div class="encoding-zone-container">
  <ng-container *ngTemplateOutlet="basicDropzone; context: xDropZoneContext"></ng-container>
  <ng-container *ngTemplateOutlet="basicDropzone; context: yDropZoneContext"></ng-container>
  <ng-template
    #basicDropzone
    let-header="header"
    let-channel="channel"
    let-fields="fields"
    let-typeAheadDoesReplace="typeAheadDoesReplace"
    let-allowContinuous="allowContinuous"
    let-allowDiscrete="allowDiscrete"
    let-allowScalars="allowScalars"
  >
    <div class="zone margin-bottom-medium" attr.data-test="{{ channel }}-zone">
      <mode-encoding-dropzone
        attr.data-test="{{ channel }}-dropzone"
        [header]="header"
        [channel]="channel"
        [isDraggable]="isDragging()"
        [placeholderClasses]="true"
        [fields]="fields"
        [template]="dragAndDrop"
        [viewSource]="queryToken$ | async"
        [view]="view$ | async"
        [isMetrics]="false"
        [allowDiscrete]="allowDiscrete"
        [allowContinuous]="allowContinuous"
        [allowScalars]="allowScalars"
        [chartType]="chartType"
        [dragField]="dragInfo"
        [typeAheadShouldReplace]="typeAheadDoesReplace"
        (dropField)="onDrop($event)"
        (dragStart)="onDragStart($event)"
        (dragEnd)="onDragEnd($event)"
        (fieldDropOnField)="onFieldDrop($event)"
      ></mode-encoding-dropzone>
    </div>
  </ng-template>
  <div class="mark-zone zone margin-bottom-medium" data-test="color-zone">
    <!-- Show simplified color palette dropdown for high charts -->
    <mode-color-palette-assignment
      *ngIf="!useMuzeRenderer"
      [selectedColorPalette]="selectedColorPalette"
      [allColorPalettes]="allColorPalettes"
      (paletteAssigned)="onPaletteAssigned($event)"
    ></mode-color-palette-assignment>
    <div class="header" *ngIf="useMuzeRenderer">Colors</div>
    <div class="pane">
      <mode-color-channel-component
        class="channel-row"
        [channelSummary]="colorMarkField"
        [encoding]="encoding"
        [model]="model"
        [view]="view"
        [renderModel]="renderModel$ | async"
        [chartService]="chartService"
        [chartType]="chartType"
        [series]="series"
        [queryToken]="queryToken$ | async"
        [queryRunToken]="queryRunToken$ | async"
        [vizToken]="vizToken$ | async"
        [fieldFormatMap]="fieldFormatMap$ | async"
        [fieldColorMap]="fieldColorMap$ | async"
        [format]="format$ | async"
        [isAutoOrManualRender]="isAutoOrManualRender$ | async"
        [useMeasureNamesPill]="true"
        [zone]="colorChannelZone"
        [allowContinuous]="useMuzeRenderer"
        [allowAggregates]="useMuzeRenderer"
        [allowDiscrete]="true"
        [disabled]="!isValidForColor"
        [hideAdvancedColorSelection]="!useMuzeRenderer"
      ></mode-color-channel-component>
      <mode-typeahead-attrs-list
        *ngIf="canReplaceColorField"
        class="empty-drop-zone--typeahead"
        [class.drag-highlight]="isDragging"
        data-test="marks-dropzone"
        dndDropzone
        placeholderText="Replace field..."
        [view]="view"
        [chartType]="chartType"
        (attrSelected)="onTypeAheadSelection($event, 'color')"
        (dndDrop)="onDropOnTypeAhead($event, 'color')"
      ></mode-typeahead-attrs-list>
    </div>
  </div>
  <div class="mark-zone zone margin-bottom-medium" *ngIf="sizeMarkField !== undefined" data-test="size-zone">
    <div class="header">Size</div>
    <div class="pane">
      <mode-channel-component
        class="channel-row"
        [channelSummary]="sizeMarkField"
        [encoding]="encoding"
        [model]="model"
        [view]="view"
        [chartService]="chartService"
        [chartType]="chartType"
        [series]="series"
        [zone]="sizeChannelZone"
        [queryToken]="queryToken$ | async"
        [vizToken]="vizToken$ | async"
        [fieldFormatMap]="fieldFormatMap$ | async"
        [format]="format$ | async"
        [allowContinuous]="true"
        [allowDiscrete]="useMuzeRenderer"
        [emitEncodingChanges]="true"
        (pendingEncodingUpdate)="handleEncodingUpdate($event)"
      ></mode-channel-component>
      <mode-typeahead-attrs-list
        *ngIf="sizeMarkField?.type === 'field'"
        class="empty-drop-zone--typeahead"
        [class.drag-highlight]="isDragging"
        data-test="marks-dropzone"
        dndDropzone
        placeholderText="Replace field..."
        [view]="view"
        [chartType]="chartType"
        (attrSelected)="onTypeAheadSelection($event, 'size')"
        (dndDrop)="onDropOnTypeAhead($event, 'size')"
      ></mode-typeahead-attrs-list>
    </div>
  </div>
</div>
